import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewContainerRef
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../app/services/base/api.service';
import { Subscription } from 'rxjs';

@Directive({
  standalone: true,
  // tslint:disable-next-line:directive-selector
  selector: '[matPaginationGoToPageDirective]',
})
export class MatPaginationGoToPageDirective implements AfterViewInit {
  selectPageComp: ComponentRef<SelectPageComponent>;

  constructor(
    private el: ElementRef,
    private paginator: MatPaginator,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.selectPageComp = this.viewContainerRef.createComponent(SelectPageComponent);

    this.paginator.page.subscribe((): void => this.selectPageComp.instance.setPage(this.paginator.pageIndex));

    this.selectPageComp.instance.pageChange.subscribe((page: number): void => {
      const prev: number = this.paginator.pageIndex;
      this.paginator.pageIndex = page;
      this.paginator.page.emit({
        pageIndex: page,
        previousPageIndex: prev,
        pageSize: this.paginator.pageSize,
        length: this.paginator.length,
      });
    });

    this.selectPageComp.instance.paginator = this.paginator;
    this.selectPageComp.instance.setPage(this.paginator.pageIndex);
  }

  ngAfterViewInit(): void {
    // tslint:disable-next-line:no-non-null-assertion
    (this.el.nativeElement as HTMLElement).querySelector('.mat-paginator-range-actions')!.before(this.selectPageComp.location.nativeElement);
  }
}

@Component({
  selector: 'fury-selectable-paginator-page-select',
  standalone: true,
  imports: [MatSelectModule, CommonModule],
  template: `
    <div class="custom-paginator-page-selector">
      <span class="mat-paginator-page-size-label">Selectie pagina:</span>
      <mat-form-field *ngIf="paginator" appearance="fill" style="width: 80px;">
        <mat-select [value]="page" (selectionChange)="pageChange.emit($event.value)">
          <mat-option *ngFor="let option of getPages()" [value]="option">{{ option + 1 }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPageComponent implements OnDestroy {
  @Input() page: number = null;
  @Input() paginator: MatPaginator = null;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  private readonly clearAllFiltersSubscription: Subscription = null;
  private readonly setGoToPageSubscription: Subscription = null;

  constructor(
    private cd: ChangeDetectorRef,
    private api: ApiService,
  ) {
    this.clearAllFiltersSubscription = this.api.clearAllFilters.subscribe((): void => this.setPage(0));
    this.setGoToPageSubscription = this.api.setGoToPage.subscribe((page: number): void => this.setPage(page));
  }

  getPages(): number[] {
    const totalPages: number = Math.ceil(this.paginator.length / this.paginator.pageSize);
    return Array.from({length: totalPages}, (_, i) => i);
  }

  setPage(page: number): void {
    this.page = page;

    const interval = setInterval((): void => this.cd.detectChanges(), 500);
    setTimeout((): void => clearInterval(interval), 5000);

    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.clearAllFiltersSubscription) {
      this.clearAllFiltersSubscription.unsubscribe();
    }
    if (this.setGoToPageSubscription) {
      this.setGoToPageSubscription.unsubscribe();
    }
  }
}
